import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('resetPassword') || initialState;

export const selectSubmitDone = createSelector(selectState, (state) => state.get('submitDone'));

export const selectErrorCode = createSelector(selectState, (state) => state.get('errorCode'));

export const selectSuccess = createSelector(selectState, (state) => state.get('success'));
